"use strict";

exports.__esModule = true;
exports.migrateFilterValueForExactMatch = migrateFilterValueForExactMatch;
exports.migrateFilteredForExactMatch = migrateFilteredForExactMatch;
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Migrate a column's active filter value when Exact match mode changes.
 *
 * - Exact (array) → search (string): keep a single selected value as the search
 *   text; clear if empty or multi-select.
 * - Search (string) → exact (array): always clear — free text is unlikely to
 *   match a discrete list value exactly.
 *
 * Returns the migrated value, or `null` when the filter should be cleared.
 */
function migrateFilterValueForExactMatch(value, exactMatch) {
  var isExactMatch = exactMatch !== false;
  if (isExactMatch) {
    if (Array.isArray(value)) {
      return value;
    }
    return null;
  }
  if (typeof value === "string") {
    return value;
  }
  if (Array.isArray(value) && value.length === 1 && value[0] != null) {
    return String(value[0]);
  }
  return null;
}

/**
 * Align active filters with each column's current Exact match setting.
 * Returns the original array reference when nothing changes.
 */
function migrateFilteredForExactMatch(filtered, columns) {
  if (filtered === void 0) {
    filtered = [];
  }
  if (columns === void 0) {
    columns = [];
  }
  var changed = false;
  var columnsById = columns.reduce(function (acc, col) {
    if (col && col.id != null) {
      acc[col.id] = col;
    }
    return acc;
  }, {});
  var next = [];
  for (var _iterator = _createForOfIteratorHelperLoose(filtered), _step; !(_step = _iterator()).done;) {
    var filter = _step.value;
    var col = columnsById[filter.id];
    if (!col || !col.canFilter) {
      next.push(filter);
      continue;
    }
    var isExactMatch = col.exactMatch !== false;
    var shapeMatches = isExactMatch ? Array.isArray(filter.value) : typeof filter.value === "string";
    if (shapeMatches) {
      next.push(filter);
      continue;
    }
    changed = true;
    var migrated = migrateFilterValueForExactMatch(filter.value, col.exactMatch);
    if (migrated == null || migrated === "") {
      continue;
    }
    next.push(Object.assign({}, filter, {
      value: migrated
    }));
  }
  return changed ? next : filtered;
}